module.exports = __webpack_public_path__ + "static/media/Inclined-Kids7.6997db96.jpg";